import { Phone } from "lucide-react";
import { Link } from "@tanstack/react-router";

import { ResponsiveImage } from "@/components/site/ResponsiveImage";
import { business } from "@/lib/business";
import { heroImage, imageSizes } from "@/lib/images";

export function Hero() {
  return (
    <section
      id="top"
      className="relative isolate min-h-[100svh] overflow-hidden"
      aria-labelledby="home-heading"
    >
      <ResponsiveImage
        image={heroImage}
        alt="Engine block being precision machined at Champion Automotive Machine Shop"
        sizes={imageSizes.hero}
        priority
        pictureClassName="absolute inset-0 -z-20"
        imgClassName="hero-parallax size-full object-cover object-[center_22%]"
      />
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "linear-gradient(90deg, oklch(0.16 0.008 260 / 0.92) 0%, oklch(0.16 0.008 260 / 0.72) 42%, oklch(0.16 0.008 260 / 0.35) 68%, oklch(0.16 0.008 260 / 0.55) 100%), linear-gradient(180deg, oklch(0.16 0.008 260 / 0.35) 0%, oklch(0.16 0.008 260 / 0.15) 45%, oklch(0.16 0.008 260 / 0.88) 100%)",
        }}
        aria-hidden="true"
      />

      <div className="mx-auto flex min-h-[100svh] max-w-6xl flex-col justify-end px-4 pt-28 pb-16 sm:justify-center sm:pt-32 sm:pb-24">
        <p className="eyebrow hero-enter hero-enter-delay-1">
          Enterprise, Alabama · Since {business.since}
        </p>
        <h1
          id="home-heading"
          className="hero-enter hero-enter-delay-2 mt-4 max-w-4xl text-6xl uppercase sm:text-8xl lg:text-9xl"
        >
          Champion
          <span className="block text-primary-text">Automotive</span>
        </h1>
        <p className="hero-enter hero-enter-delay-3 mt-2 font-display text-2xl tracking-[0.18em] text-steel uppercase sm:text-3xl">
          Machine Shop
        </p>
        <p className="hero-enter hero-enter-delay-4 mt-6 max-w-xl text-lg text-muted-foreground sm:text-xl">
          Precision engine machining for auto, truck, diesel, farm tractor and motorcycle engines —
          done right so your rebuild runs stronger and lasts longer.
        </p>

        <div className="hero-enter hero-enter-delay-5 mt-9 flex flex-wrap gap-3">
          <a href={business.phoneHref} className="btn-base btn-primary text-xl">
            <Phone className="size-5" aria-hidden="true" />
            Call {business.phone}
          </a>
          <Link to="/services" className="btn-base btn-outline">
            View machine services
          </Link>
        </div>
      </div>
      <div className="h-2 checker-strip" aria-hidden="true" />
    </section>
  );
}
